import { render, staticRenderFns } from "./RSSuggestionsEdit.vue?vue&type=template&id=9126b730&scoped=true"
import script from "./RSSuggestionsEdit.vue?vue&type=script&lang=js"
export * from "./RSSuggestionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9126b730",
  null
  
)

export default component.exports